<template>

    <div class="container middle">

      <div class="image-container">
        <img src="../img/plannerlogo.svg"></img>
      </div>

      <div class="login-header">
        <p>Enter your email to change your password</p>
      </div>

      <div class="inputs">
        <div class="input-container">
          <label>Email:</label>
          <input v-model="email" type="text">
          <button v-on:click="resetPassword()" class="reset-button">Reset password</button>
          <button v-on:click="backToLogin()" class="back-button">Back</button>
        </div>

        <div class="buttons">

        </div>

      </div>

  </div>

</template>

<script>

  import firebase from 'firebase'

  export default {
    name: 'login',
    title: 'Runner - Login',
    data() {
      return {
        email: ''
      }
    },
    methods: {
      resetPassword() {
        console.log("resetting password")
        firebase.auth().sendPasswordResetEmail(this.email).then(function() {
          // Email sent.
          alert('We have sent you an email, please follow the instructions.')
        }).catch(function(error) {
          // An error happened.
          alert('Cannot reset password. Verify you typed email correctly!')
        });
      },
      backToLogin() {
        this.$router.replace('login')
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .container {
    padding: 10%;
    justify-content: flex-start !important;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 10px;
    flex: 1;
  }

  .inputs .input-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-top: 40px;

    label {
      font-size: $font-medium;
    }

  }

  button {
    padding-top: 5px;
    padding-bottom: 5px;
    color: white;
    border: none;
    border-radius: 8px;
    align-self: center;
    font-size: $font-semiSemiLarge;
    font-weight: bold;
  }

  .reset-button {
    background-color: $cyan;
    width: 50%;
    margin-top: 50px;
  }

  .back-button {
    background-color: $yellow;
    width: 35%;
    margin-top: 30px;
  }

  .buttons {
    flex-direction: column;
    display: flex;
  }

  .login-header {

    text-align: center;

    label {
      font-size: $font-large;
      font-weight: bold;
      margin: 0 0;
      color: $cyan;
      font-family: $opensans;
      font-size: 26px;
    }

    p {
      font-size: $font-semiSemiLarge;
      margin-bottom: 0px;
    }
  }

  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-top:10px;
      width: 110px;
      height: 110px;
    }
  }


  @media screen and (min-width: 1140px) {

    .container.middle {
      padding: 0px 30px 40px 30px;
      width: 400px !important;
      height: 480px !important;
    }

    .login-header {
      margin-top: 50px;
    }

    .image-container {
      img {
        position: absolute;
        top: -55px;
        z-index: 99;
      }
    }

    .register-container {
      justify-content: center;
    }

  }

</style>
